import { useQuery } from '@tanstack/react-query'

import { GET_RESOURCE_RAMP_CURVES_API_ID, getRampCurves } from '@/features/resource/endpoints/resources'

export function useRampCurvesQuery(resourceId: string) {
  return useQuery({
    queryKey: [GET_RESOURCE_RAMP_CURVES_API_ID, { resourceId }],
    queryFn: () => getRampCurves(resourceId),
    enabled: !!resourceId,
  })
}
